import { DashboardModule, Form } from '@domain-group/suit-theme'

import PortalDataInput from '../PortalDataInput'

const BasicFeatures = () => (
  <DashboardModule boxProps={{ flexDirection: 'column', marginBottom: 'large' }} title="Basic Features">
    <Form padding="large">
      <Form.Row>
        <Form.Row>
          <PortalDataInput fieldKey="bedrooms" />

          <PortalDataInput marginTop={['large', 0]} fieldKey="bathrooms" />
        </Form.Row>

        <Form.Row>
          <PortalDataInput marginTop={['large', 0]} fieldKey="garages" />

          <PortalDataInput marginTop={['large', 0]} fieldKey="carports" />
        </Form.Row>
      </Form.Row>

      <Form.Row>
        <Form.Row>
          <PortalDataInput marginTop="large" fieldKey="openSpaces" />

          <PortalDataInput marginTop="large" fieldKey="livingArea" />
        </Form.Row>

        <Form.Row>
          <PortalDataInput marginTop="large" fieldKey="toilet" />

          <PortalDataInput marginTop="large" fieldKey="ensuite" />
        </Form.Row>
      </Form.Row>

      <Form.Row>
        <PortalDataInput marginTop="large" fieldKey="study" />
      </Form.Row>
    </Form>
  </DashboardModule>
)

export default BasicFeatures
